import React, { useState, useEffect, lazy, Suspense } from "react";
import PeriodSlider from "../../components/GlobalComponents/PeriodSlider/PeriodSlider";
import { useSelector } from "react-redux";
import { useGetPriodById } from "../../components/Login/Hooks/Index";
import CircularProgress from "@mui/material/CircularProgress";
import { Grid, Box, Typography } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PersonalOkRs from "./LComponents/PersonalOkRs/PersonalOkRs";
import AllOkRs from "./LComponents/AllOkRs/AllOkRs";
import FilterSVG from "../../components/svg/filterSvg";
import CloseSVG from "../../components/svg/closeSvg";
import ObjectiveFilter from "./new/objectivesFilter";
import { useQuery, useQueryClient } from "react-query";
import { getFilterByTenantId } from "./Api";
import { objectiveFilterType } from "../../types";
import {
  useGetAllObjectiveByPeriodId,
  useGetAllObjectiveByPersonId,
  useGetFilterByTenantId,
} from "./Hooks";
import ModalLyt from "../../components/Layouts/ModalLyt/ModalLyt";
import CreateObjective from "./Forms/CreateObjective/CreateObjective";
import DYToastMessage from "../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import DyButton from "../../components/GlobalComponents/DyButton/DyButton";
import MyKeyResults from "./LComponents/MyKeyResults/MyKeyResults";
import { NewUseStore } from "../../Store/newUseStore";
import AllKeyResults from "./LComponents/AllKeyResults/AllKeyResults";
import { useGetObjectiveAndKeyResultCountByPeriodId } from "../Reports/Hooks";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const Index: React.FC = function () {
  // const [priodId, setPriodId] = useState<string | null>(null);
  const [value, setValue] = React.useState(0);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [filterData, setFilterData] = useState<any>(false);
  const [objetcideData, setObjetcideData] = useState<any>(false);
  const [selectedItemsInFilter, setSelectedItemsInFilter] = useState<any>([]);
  const [objetcidePersonData, setObjetcidePersonData] = useState<any>(false);
  const [filterIsOn, setFilterIsOn] = useState<boolean>(false);
  // const [perData, setPerData] = useState<any>(false);
  const queryClient = useQueryClient();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه


  const objectiveChanged = NewUseStore((state) => state.objectiveChanged);
  const updateObjectiveChanged = NewUseStore(
    (state) => state.updateObjectiveChanged
  );

  
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const onFailed = (): void => {};

  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );

  ////Add OKR AMIR
  const [showAddObjective, setShowAddObjective] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [objectiveAsynOpcState, setObjectiveAsyncOpState] = useState<any>(null);

  const initialAddObjective = (): void => {
    setShowAddObjective((prev) => !prev);
  };
  const setPeriodIdData = (id: string) => {
    setPeriodId(id);
  };

  const onSuccesss = (data: any) => {
    let length = data?.map((e: any) => e.isCurrent).indexOf(true);
    setPeriodId(data[length].id);
    setActiveIndex(length);
  };
  
  const [objCount, SetobjCount] = useState<any>('');
  const [myObjCount, SetMyObjCount] = useState<any>('');
  const [krCount, SetKrCount] = useState<any>('');
  const [myKrCount, SetMyKrCount] = useState<any>('');

  const {
    data: perData,
    isLoading: perLoading,
    isError: periodError,
    isFetched,
  }: any = useGetPriodById(tenantId, onSuccesss, onFailed);
  // const[periodId,setPeriodId]=useState<string|null>(null);

  const applyFilter = () => {
    if (!objetcideDataRead || objetcideDataRead.length === 0) return;
    let objetcideDataLocal: any[] = [];
    let objetcidePersonDataLocal: any[] = [];
    let selectedstateDtosIds: string[] = [];
    let selectedteamDtosIds: string[] = [];
    let selectedpersonDtosIds: string[] = [];
    filterData.stateDtos.map(
      (item: objectiveFilterType) =>
        item.checked && selectedstateDtosIds.push(item.id)
    );
    filterData.teamDtos.map(
      (item: objectiveFilterType) =>
        item.checked && selectedteamDtosIds.push(item.id)
    );
    filterData.personDtos.map(
      (item: objectiveFilterType) =>
        item.checked && selectedpersonDtosIds.push(item.id)
    );

    selectedpersonDtosIds.length > 0 ||
    selectedteamDtosIds.length > 0 ||
    selectedstateDtosIds.length > 0
      ? setFilterIsOn(true)
      : setFilterIsOn(false);

    objetcideDataRead.map((item: any) => {
      const index1: number = selectedteamDtosIds.findIndex(
        (element) => element === item.definitionLevelId
      );
      const index2: number = selectedstateDtosIds.findIndex(
        (element) => element === item.objectivesStateId
      );
      const index3: number = selectedpersonDtosIds.findIndex(
        (element) => element === item.responsibleId
      );
      if (
        (selectedteamDtosIds.length === 0 ||
          (selectedteamDtosIds.length > 0 && index1 >= 0)) &&
        (selectedstateDtosIds.length === 0 ||
          (selectedstateDtosIds.length > 0 && index2 >= 0)) &&
        (selectedpersonDtosIds.length === 0 ||
          (selectedpersonDtosIds.length > 0 && index3 >= 0))
      )
        objetcideDataLocal.push(item);
      //if (index1 + index2 + index3 > -3) objetcideDataLocal.push(item);
    });

    objetcidePersonDataRead.map((item: any) => {
      const index1: number = selectedteamDtosIds.findIndex(
        (element) => element === item.definitionLevelId
      );
      const index2: number = selectedstateDtosIds.findIndex(
        (element) => element === item.objectivesStateId
      );
      const index3: number = selectedpersonDtosIds.findIndex(
        (element) => element === item.responsibleId
      );
      if (
        (selectedteamDtosIds.length === 0 ||
          (selectedteamDtosIds.length > 0 && index1 >= 0)) &&
        (selectedstateDtosIds.length === 0 ||
          (selectedstateDtosIds.length > 0 && index2 >= 0)) &&
        (selectedpersonDtosIds.length === 0 ||
          (selectedpersonDtosIds.length > 0 && index3 >= 0))
      )
        objetcidePersonDataLocal.push(item);
    });
    setObjetcideData(objetcideDataLocal);
    setObjetcidePersonData(objetcidePersonDataLocal);
  };

  const filterDataDone = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    applyFilter();
    setShowFilter(!showFilter);
  };

  const filterClear = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    let localData: any = { ...filterData };

    localData.personDtos = localData.personDtos.map(
      (item: objectiveFilterType) => ({
        ...item,
        checked: false,
      })
    );
    localData.stateDtos = localData.stateDtos.map(
      (item: objectiveFilterType) => ({
        ...item,
        checked: false,
      })
    );
    localData.teamDtos = localData.teamDtos.map(
      (item: objectiveFilterType) => ({
        ...item,
        checked: false,
      })
    );
    setFilterData(localData);
    setSelectedItemsInFilter(localData);
    setShowFilter(!showFilter);
    setObjetcideData(objetcideDataRead);
    setObjetcidePersonData(objetcidePersonDataRead);
    setFilterIsOn(false);
  };

  const setRadioFilterChecked = (name: string, id: string) => {
    let tmpData: any = { ...filterData };
    tmpData[name] = tmpData[name].map((item: objectiveFilterType) =>
      item.id === id ? { ...item, checked: !item.checked } : { ...item }
    );

    setSelectedItemsInFilter(tmpData);
    setFilterData(tmpData);
  };

  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [periodId, setPeriodId] = useState<string | null>(null);

  const onSuccesssGetFilterData = (data: any) => {
    let localData: any;

    if (filterIsOn) {
      localData = { ...data };
      localData.personDtosChecked = selectedItemsInFilter.personDtosChecked;
      localData.personDtos = data.personDtos.map((item: objectiveFilterType) =>
        selectedItemsInFilter.personDtos.findIndex(
          (itm: objectiveFilterType) => itm.id === item.id
        ) > -1
          ? {
              ...item,
              checked: selectedItemsInFilter.personDtos.find(
                (itm: objectiveFilterType) => itm.id === item.id
              ).checked,
            }
          : { ...item, checked: false }
      );
      localData.stateDtosChecked = selectedItemsInFilter.stateDtosChecked;
      localData.stateDtos = data.stateDtos.map((item: objectiveFilterType) =>
        selectedItemsInFilter.stateDtos.findIndex(
          (itm: objectiveFilterType) => itm.id === item.id
        ) > -1
          ? {
              ...item,
              checked: selectedItemsInFilter.stateDtos.find(
                (itm: objectiveFilterType) => itm.id === item.id
              ).checked,
            }
          : { ...item, checked: false }
      );
      localData.teamDtosChecked = selectedItemsInFilter.teamDtosChecked;
      localData.teamDtos = data.teamDtos.map((item: objectiveFilterType) =>
        selectedItemsInFilter.teamDtos.findIndex(
          (itm: objectiveFilterType) => itm.id === item.id
        ) > -1
          ? {
              ...item,
              checked: selectedItemsInFilter.teamDtos.find(
                (itm: objectiveFilterType) => itm.id === item.id
              ).checked,
            }
          : { ...item, checked: false }
      );
    } else localData = { ...data };

    setSelectedItemsInFilter(localData);
    setFilterData(localData);
  };

  useGetFilterByTenantId(tenantId, periodId, onSuccesssGetFilterData);

  const onSuccesssGetAllObjectiveData = (data: any) => {
    geta();
    if (!filterIsOn) setObjetcideData(data);
    getObjectivesPersonAgain();
  };

  const {
    data: objetcideDataRead,
    isLoading: getObjectiveLoading,
    isFetched: getObjectivesIsFetched,
    refetch: getObjectivesAgain,
  } = useGetAllObjectiveByPeriodId(
    periodId,
    tenantId,
    onSuccesssGetAllObjectiveData
  );

  const{data:countData, refetch: geta}=useGetObjectiveAndKeyResultCountByPeriodId(periodId,tenantId);

  useEffect(() => {
    if (countData) {
      SetobjCount(countData?.objectiveCount);
      SetMyObjCount(countData?.myObjectiveCount);
      SetKrCount(countData?.keyResultCount);
      SetMyKrCount(countData?.myKeyResultCount);
    }
  }, [countData]);

  const onSuccesssGetAllObjectivePersonData = (data: any) => {
    if (filterIsOn) applyFilter();
    else setObjetcidePersonData(data);
  };

  const {
    data: objetcidePersonDataRead,
    isLoading: getObjectivePersonLoading,
    isError,
    isFetched: isFetchedPerson,
    refetch: getObjectivesPersonAgain,
  } = useGetAllObjectiveByPersonId(
    periodId,
    tenantId,
    onSuccesssGetAllObjectivePersonData
  );

  // AMIR useEffect(() => {
  //   const active: any = perData ? perData[activeIndex] : {};
  //   setPeriodId(active.id);
  // }, [activeIndex]);

  //AMIR useEffect(() => {
  //   //  console.log(activeIndex)
  //   let length = perData?.map((e: any) => e.isCurrent).indexOf(true);
  //   // setActiveIndex(4)
  //   if (length !== 4) {
  //     setActiveIndex(4);
  //   }
  // }, []);

  //AMIR useEffect(() => {
  //   // console.log(getPeriodFetched)
  //   if (perData) {
  //     let length: number = perData.length;
  //     if (length === 4) {
  //       setActiveIndex(0);
  //     }
  //   }
  // }, [perData]);

  //   useEffect(() => {
  // console.log(periodId)
  //   }, [periodId]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div className="flex-col">
      <PeriodSlider
        setActiveIndex={setActiveIndex}
        setPriodId={setPeriodId}
        activeIndex={activeIndex} //AMIR {perData?.findIndex((item: any) => item.isCurrent)}
        tenantId={tenantId}
        slideData={perData}
        dataLoading={perLoading}
      />
      <div className="w-full flex justify-end items-center gap-x-3 h-6">
        <div>
          <button
            onClick={(e: React.MouseEvent<HTMLElement>) =>
              initialAddObjective()
            }
            className={`btn px-6  text-xs font-thin text-white bg-[#00387c]
               btn-sm rounded-md`}
          >
            ایجاد هدف 
          </button>

          <ModalLyt
            showModal={showAddObjective}
            setShowModal={setShowAddObjective}
            width={isMobile ? '350px' : '900px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            height={900}
            title={"هدف جدید"}
          >
            <CreateObjective
              periodsData={perData}
              onSuccess={setShowAddObjective}
              setShowToastMessage={setShowToastMessage}
              //setAddObjectiveStatus = {setAddObjectiveStatus}
              setObjectiveAsyncOpState={setObjectiveAsyncOpState}
              afterSuccess={getObjectivesAgain}
              periodId={periodId}
              onClose={setShowAddObjective}
            />
          </ModalLyt>
        </div>

        <div className=" relative cursor-pointer ">
          {(objetcidePersonData || objetcideData) && (
            <button
              onClick={(e: React.MouseEvent<HTMLElement>) =>
                setShowFilter(!showFilter)
              }
              className={`btn px-6 w-20 text-xs font-thin text-white ${
                filterIsOn ? "bg-[#f85700] " : "bg-[#00387c]"
              } btn-sm rounded-md  ml-3`}
            >
              {!showFilter ? (
                "فیلتر"
              ) : (
                <div className="w-5 h-5">
                  <CloseSVG fill={`white`} />
                </div>
              )}
            </button>
          )}
          {showFilter && (
            <div className="absolute mt-2 left-0">
              <ObjectiveFilter
                data={filterData}
                setRadioChecked={setRadioFilterChecked}
                showModal={showFilter}
                filterDone={filterDataDone}
                filterClear={filterClear}
              />
            </div>
          )}
        </div>
      </div>
      <Grid container>
        <Grid item xs={12} md={12}>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                   label={`همه اهداف (${objCount})`} 
                  {...a11yProps(0)}
                  style={{ color: "black", fontWeight: "700" }}
                />
                <Tab
                   label={`همه نتایج (${krCount})`} 
                  {...a11yProps(1)}
                  style={{ color: "black", fontWeight: "700" }}
                />
                <Tab
                   label={`اهداف من (${myObjCount})`} 
                  {...a11yProps(2)}
                  style={{ color: "black", fontWeight: "700" }}
                />
                 <Tab
                   label={`نتایج من (${myKrCount})`} 
                  {...a11yProps(3)}
                  style={{ color: "black", fontWeight: "700" }}
                />
              </Tabs>
            </Box>

            <CustomTabPanel value={value} index={0}>
              <Suspense
                fallback={
                  <Box width={"100%"} pt={5} textAlign={"center"} py={5}>
                    <CircularProgress />
                  </Box>
                }
              >
                <AllOkRs
                  periodId={periodId}
                  periodsData={perData}
                  allObjective={objetcideData}
                  getObjectiveLoading={getObjectiveLoading}
                  isFetched={getObjectivesIsFetched}
                  filterIsOn={filterIsOn}
                  afterSuccess={getObjectivesAgain}
                />
              </Suspense>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
              <Suspense
                fallback={
                  <Box width={"100%"} pt={5} textAlign={"center"} py={5}>
                    <CircularProgress />
                  </Box>
                }
              >
                <AllKeyResults
                  periodId={periodId}
                  periodsData={perData}
                  allObjective={objetcidePersonData}
                  getObjectiveLoading={getObjectivePersonLoading}
                  isFetched={isFetchedPerson}
                  filterIsOn={filterIsOn}
                  afterSuccess={getObjectivesAgain}
                />
              </Suspense>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={2}>
              <Suspense
                fallback={
                  <Box width={"100%"} pt={5} textAlign={"center"} py={5}>
                    <CircularProgress />
                  </Box>
                }
              >
                <PersonalOkRs
                  periodId={periodId}
                  periodsData={perData}
                  allObjective={objetcidePersonData}
                  getObjectiveLoading={getObjectivePersonLoading}
                  isFetched={isFetchedPerson}
                  filterIsOn={filterIsOn}
                  afterSuccess={getObjectivesAgain}
                />
              </Suspense>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={3}>
              <Suspense
                fallback={
                  <Box width={"100%"} pt={5} textAlign={"center"} py={5}>
                    <CircularProgress />
                  </Box>
                }
              >
                <MyKeyResults
                  periodId={periodId}
                  periodsData={perData}
                  allObjective={objetcidePersonData}
                  getObjectiveLoading={getObjectivePersonLoading}
                  isFetched={isFetchedPerson}
                  filterIsOn={filterIsOn}
                  afterSuccess={getObjectivesAgain}
                />
              </Suspense>
            </CustomTabPanel>
          </Box>
        </Grid>
        {showToastMessage && (
          <DYToastMessage
            //isSuccess={addObjectiveStatus?.isSuccess}
            //message={addObjectiveStatus?.metaData.message}
            isSuccess={objectiveAsynOpcState?.isSuccess}
            message={objectiveAsynOpcState?.metaData.message}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
        {objectiveChanged.show && (
          <DYToastMessage
            //isSuccess={addObjectiveStatus?.isSuccess}
            //message={addObjectiveStatus?.metaData.message}
            isSuccess={objectiveChanged.state}
            message={objectiveChanged.message}
            setShow={() =>
              updateObjectiveChanged({
                state: objectiveChanged.state,
                message: "",
                show: !objectiveChanged.show,
              })
            }
            show={objectiveChanged.show}
          />
        )}

      </Grid>
    </div>
  );
};

export default Index;
